// extracted by mini-css-extract-plugin
export default {"tabsPopup":"tabsPopup__cL7kg","tabsPopup__icon":"tabsPopup__icon__te2QE","tabsPopup__list":"tabsPopup__list__CBRxu"};